import { ReactElement } from 'react';

export enum UiContextMenuSubX {
  TOP = 'top',
  BOTTOM = 'bottom',
}

export enum UiContextMenuSubY {
  RIGHT = 'right',
  LEFT = 'left',
}

export interface UiContextMenuPositionInterface {
  x: number;
  y: number;
  subX: UiContextMenuSubX;
  subY: UiContextMenuSubY;
}

export enum UiContextMenuConfigPosition {
  TOP_LEFT = 'top-left',
  TOP_RIGHT = 'top-right',
  BOTTOM_RIGHT = 'bottom-right',
  BOTTOM_LEFT = 'bottom-left',
  BOTTOM = 'bottom',
  RIGHT = 'right',
}

export type UiContextMenuConfigPositionType =
  | UiContextMenuConfigPosition.TOP_RIGHT
  | UiContextMenuConfigPosition.BOTTOM_RIGHT
  | UiContextMenuConfigPosition.BOTTOM
  | UiContextMenuConfigPosition.RIGHT
  | UiContextMenuConfigPosition.BOTTOM_LEFT;

export interface UiContextMenuConfig {
  overlaybgClass?: string;
  contextMenuBgClass?: string;
  position?: UiContextMenuConfigPositionType;
  menuPadding?: number;
  theme?: UiContextMenuTheme;
}
export interface UiContextMenuState {
  isShown: boolean;
  items: ContextMenuItemData[];
  position: UiContextMenuPositionInterface;
  config: UiContextMenuConfig;
  themeClassesMenu?: string;
  themeClassesItem?: string;
  additionalStyles?: string;
  zIndex?: number;
  usePopperSubmenu?: boolean;
}

export interface IconsMap {
  [key: string]: JSX.Element;
}

export enum ContextMenuItemType {
  HTML,
  DEFAULT,
}
export type ContextMenuItemData = MenuItemHtml | MenuItemDefault;

export interface UiContentMenuItemBase {
  type: ContextMenuItemType;
  isSeparator?: boolean;
  subMenu?: ContextMenuItemData[];
  isChecked?: boolean;
  textStyleClasses?: string;
  closeOnClick?: boolean;
  additionalStyles?: string;
  classes?: string;
  subMenuAdditionStyles?: string;
  id?: string;
  disabled?: boolean;
  tooltip?: string;
  action?: () => void;
}
export interface MenuItemHtml extends UiContentMenuItemBase {
  html: ReactElement;
  type: ContextMenuItemType.HTML;
}

export interface MenuItemDefault extends UiContentMenuItemBase {
  type: ContextMenuItemType.DEFAULT;
  title: string;
  icon?: ReactElement;
  iconStyles?: string;
  titleStyles?: string;
  newFeature?: boolean;
}

export interface UiContextMenuProps {
  menuData: ContextMenuItemData[];
  x: number;
  y: number;
  closeContextMenu: () => void;
  subX: UiContextMenuSubX;
  subY: UiContextMenuSubY;
  subMenuPositionLeft?: boolean;
  theme?: UiContextMenuTheme;
  themeClassesMenu?: string;
  themeClassesItem?: string;
  additionalStyles?: string;
  zIndex?: number;
  usePopperSubmenu?: boolean;
}

export type UiContextMenuItemProps = {
  item: ContextMenuItemData;
  classes?: { menu: string; item: string };
  closeContextMenu: () => void;
  subX: UiContextMenuSubX;
  subY: UiContextMenuSubY;
  theme?: UiContextMenuTheme;
  usePopperSubmenu?: boolean;
};

export interface UiContextMenuSubProps {
  menuData: ContextMenuItemData[];
  closeContextMenu: () => void;
  subMenuPositionLeft?: boolean;
  subX: UiContextMenuSubX;
  subY: UiContextMenuSubY;
  theme?: UiContextMenuTheme;
  additionStyles?: string;
  classes:
    | {
        menu: string;
        item: string;
      }
    | undefined;
  usePopperSubmenu?: boolean;
}

export enum UiContextMenuTheme {
  LIGHT = 'light',
  DARK = 'dark',
}
